import gsap from 'gsap';

export default CircleHeader = () => {

    const circleHeaders = document.querySelectorAll('.circle-header');
    circleHeaders.forEach((header) => {

        const circleLines = header.querySelectorAll('.circle-line');
        circleLines.forEach((line, i) => {

            const animate = () => {
                gsap.to(line, {
                    delay: line.classList.contains('svg-line-2') ? 0.25 : 0,
                    rotate: 0,
                    duration: 1,
                    ease: 'power2.out',
                })
            }

            gsap.to(line, {
                scrollTrigger: {
                trigger: header,
                start: 'top 90%',
                invalidateOnRefresh: true,
                onEnter: () => {
                    animate();
                },
                },
            })
        })
    })
}